import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen } from 'lucide-react';
const names = ['María', 'Ana', 'Carolina', 'Gabriela', 'Fernanda', 'Alejandra', 'Daniela', 'Paola', 'Lucía', 'Martina', 'Camila', 'Sofía', 'Valentina'];
const cities = ['Buenos Aires', 'Bogotá', 'Lima', 'Ciudad de México', 'Santiago', 'Montevideo', 'Medellín', 'Quito', 'Córdoba', 'Guadalajara', 'Rosario', 'Cali'];
export const PurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    const triggerPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentName(randomName);
      setCurrentCity(randomCity);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      triggerPopup();
      // Then set interval between 8 and 15 seconds
      const interval = setInterval(() => {
        triggerPopup();
      }, Math.floor(Math.random() * (15000 - 8000 + 1) + 8000));
      return () => clearInterval(interval);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  return <AnimatePresence data-id="element-292">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 left-4 right-4 sm:right-auto z-50 bg-white rounded-xl shadow-2xl border border-gray-100 p-3 sm:p-4 flex items-center gap-3 sm:gap-4 max-w-none sm:max-w-[300px]" data-id="element-293">
          <div className="bg-gold-100 p-2 rounded-full text-gold-600 shrink-0" data-id="element-294">
            <BookOpen size={16} className="sm:w-5 sm:h-5" data-id="element-295" />
          </div>
          <div data-id="element-296">
            <p className="text-xs sm:text-sm text-gray-800 font-medium leading-tight" data-id="element-297">
              <span className="font-bold" data-id="element-298">{currentName}</span> de {currentCity}{' '}
              acaba de comprar este libro digital
            </p>
            <p className="text-[10px] sm:text-xs text-gray-400 mt-1" data-id="element-299">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};